module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Billing & Invoice Details")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "summary-card-small bg-primary"
  }, [_c('div', {
    staticClass: "card-content-small"
  }, [_c('h5', [_vm._v("Total Invoices")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.billingSummary.totalInvoices || 0))])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "summary-card-small bg-success"
  }, [_c('div', {
    staticClass: "card-content-small"
  }, [_c('h5', [_vm._v("Total Billed Amount")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.formatCurrency(_vm.billingSummary.totalBilledAmount || 0)))])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "summary-card-small bg-info"
  }, [_c('div', {
    staticClass: "card-content-small"
  }, [_c('h5', [_vm._v("Paid Amount")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.formatCurrency(_vm.billingSummary.paidAmount || 0)))])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "summary-card-small bg-warning"
  }, [_c('div', {
    staticClass: "card-content-small"
  }, [_c('h5', [_vm._v("Pending Amount")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.formatCurrency(_vm.billingSummary.pendingAmount || 0)))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Invoice No")]), _vm._v(" "), _c('th', [_vm._v("Invoice Date")]), _vm._v(" "), _c('th', [_vm._v("Job No")]), _vm._v(" "), _c('th', [_vm._v("Assignment No")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Job Type")]), _vm._v(" "), _c('th', [_vm._v("Branch")]), _vm._v(" "), _c('th', [_vm._v("Invoice Amount")]), _vm._v(" "), _c('th', [_vm._v("Paid Amount")]), _vm._v(" "), _c('th', [_vm._v("Pending Amount")]), _vm._v(" "), _c('th', [_vm._v("Billing Status")]), _vm._v(" "), _c('th', [_vm._v("Tally Status")]), _vm._v(" "), _c('th', [_vm._v("Payment Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.billingData), function(billing, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(billing.invoiceNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(billing.invoiceDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(billing.jobNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(billing.assignmentNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(billing.clientName))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": billing.jobType === 'FF_EXP' ?
          'primary' :
          billing.jobType === 'FF_IMP' ?
          'info' :
          billing.jobType === 'CC_EXP' ?
          'success' :
          billing.jobType === 'CC_IMP' ?
          'warning' :
          'secondary'
      }
    }, [_vm._v(_vm._s(billing.jobType))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(billing.branchName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(billing.invoiceAmount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(billing.paidAmount)))]), _vm._v(" "), _c('td', [_c('span', {
      class: billing.pendingAmount > 0 ? 'text-danger' : 'text-success'
    }, [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(billing.pendingAmount)) + "\n                ")])]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": billing.billingStatus === 'Completed' ?
          'success' :
          billing.billingStatus === 'Pending' ?
          'warning' :
          'secondary'
      }
    }, [_vm._v(_vm._s(billing.billingStatus))])], 1), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": billing.tallyStatus === 'Added to Tally' ?
          'success' :
          billing.tallyStatus === 'Pending' ?
          'warning' :
          'secondary'
      }
    }, [_vm._v(_vm._s(billing.tallyStatus))])], 1), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": billing.paymentStatus === 'Paid' ?
          'success' :
          billing.paymentStatus === 'Partial' ?
          'warning' :
          'danger'
      }
    }, [_vm._v(_vm._s(billing.paymentStatus))])], 1)])
  }), _vm._v(" "), (_vm.billingData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "13"
    }
  }, [_vm._v("\n                No data available\n              ")])]) : _vm._e()], 2)])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b593fb3e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/BillingSection.vue
// module id = 2841
// module chunks = 0